import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@Components/Tooltip';
import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon } from '@els/els-react--button';

function InfoTooltipOnClickTrigger({ className, children, label = 'info' }) {
  useEffect(() => {
    Tooltip.rebuild();
  }, []);

  return (
    <Flyout
      shouldCloseOnESC
      showCloseButton
      placement="top-start"
      flyout={<div className={`${className} info-tooltip-content`}>{children}</div>}>
      <ButtonWithIcon
        type="link"
        className="u-els-color-info u-els-display-inline-block"
        onClick={(e) => {
          e.stopPropagation();
        }}
        sprite="InformationOutlineCircle"
        linkIconSize="xxs"
        iconOnly>
        {label}
      </ButtonWithIcon>
    </Flyout>
  );
}

InfoTooltipOnClickTrigger.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default InfoTooltipOnClickTrigger;
